export const isKeyboardFocus = () => Boolean(document.activeElement?.matches(':focus-visible'));
